import { commitMutation, graphql, Environment } from 'react-relay';
import { MutationConfig } from 'relay-runtime';
import { UserLogoutMutation } from './__generated__/UserLogoutMutation.graphql';

const mutation = graphql`
  mutation UserLogoutMutation($input: LogoutInput!) {
    logout(input: $input) {
      clientMutationId
    }
  }
`;

type UserLogoutMutationCommit = Omit<
  MutationConfig<UserLogoutMutation>,
  'mutation' | 'variables'
> & {
  environment: Environment;
};

function commit({
  environment,
  onCompleted,
  onError,
}: UserLogoutMutationCommit) {
  const variables = { input: { id: '123' } };
  return commitMutation<UserLogoutMutation>(environment, {
    mutation,
    variables,
    onCompleted,
    onError,
  });
}

export default {
  commit,
};
